// Mock data for Boss Detailing Pros

export const services = [
  {
    id: 1,
    title: 'Interior & Exterior Detailing',
    description: 'Complete cleaning inside and out for a showroom finish',
    icon: 'Sparkles',
    image: 'https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7'
  },
  {
    id: 2,
    title: 'Interior Shampoo',
    description: 'Deep clean and stain removal for pristine interiors',
    icon: 'Armchair',
    image: 'https://images.pexels.com/photos/6003/man-hand-car-black.jpg'
  },
  {
    id: 3,
    title: 'Car Waxing & Ceramic Coating',
    description: 'Premium protection and shine that lasts',
    icon: 'Shield',
    image: 'https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03'
  },
  {
    id: 4,
    title: 'Fleet Detailing',
    description: 'Professional service for multiple vehicles',
    icon: 'Truck',
    image: 'https://images.unsplash.com/photo-1580679568899-be51739ba2df'
  },
  {
    id: 5,
    title: 'Maintenance Detailing',
    description: 'Keep your vehicle in top condition year-round',
    icon: 'Wrench',
    image: 'https://images.unsplash.com/photo-1708805282683-50a060eba80f'
  }
];

export const packages = [
  {
    id: 1,
    name: 'Luxury Wash & Detail',
    tag: 'MOST POPULAR',
    price: '$225.00+',
    duration: '2 hrs+',
    features: [
      'Exterior Foam Bath',
      'Interior Vacuum',
      'Windows In & Out',
      'Tire Scrub & Shine',
      'Dashboard Protection'
    ]
  },
  {
    id: 2,
    name: 'Executive Shine Wash & Interior Detail',
    tag: 'ALL IN ONE',
    price: 'Price Varies',
    duration: '24 hrs',
    features: [
      'Complete Interior Shampoo',
      'Exterior Detailing',
      'Clay Bar Treatment',
      'Leather Conditioning',
      'Full Protection Package'
    ]
  },
  {
    id: 3,
    name: 'Executive Interior Shampoo',
    tag: null,
    price: '$275.00+',
    duration: '1 hr 30 mins+',
    features: [
      'Deep Carpet Cleaning',
      'Stain Removal',
      'Leather Treatment',
      'Heated Extraction',
      'Sanitization'
    ]
  },
  {
    id: 4,
    name: 'Big Boss Wash & Detail',
    tag: 'PREMIUM',
    price: '$375.00+',
    duration: '3 hr 30 min+',
    features: [
      'Clay Bar & Paint Decontamination',
      'Dashboard Protect & Shine',
      'Exterior Foam Bath',
      'Complete Interior Shampoo',
      'Heated Extraction',
      'Black Trim Restore',
      '6 Month Ceramic Wax Sealant'
    ]
  },
  {
    id: 5,
    name: '1 Year Ceramic Coating',
    tag: null,
    price: 'Price Varies',
    duration: '24 hrs',
    features: [
      'Paint Correction',
      'Professional Ceramic Application',
      '1 Year Protection',
      'UV Protection',
      'Hydrophobic Coating'
    ]
  },
  {
    id: 6,
    name: '5 Year Ceramic Coating',
    tag: 'ULTIMATE',
    price: 'Price Varies',
    duration: '24 hrs',
    features: [
      'Stage 1 Paint Correction',
      'Premium Ceramic Application',
      '5 Year Protection',
      'Maximum UV Protection',
      'Self-Healing Top Coat'
    ]
  }
];

export const addOns = [
  { id: 1, name: 'Ceramic Leather Coating', price: '$150.00+', duration: '5 mins' },
  { id: 2, name: 'Interior Shine', price: '$25.00', duration: '5 mins' },
  { id: 3, name: 'Leather Clean & Treatment', price: '$30.00', duration: '5 mins' },
  { id: 4, name: 'Black Trim Restoration', price: '$25.00', duration: '5 mins' },
  { id: 5, name: 'Hair Removal', price: '$50.00', duration: '5 mins' },
  { id: 6, name: 'Headliner Cleaning', price: '$50.00', duration: '5 mins' },
  { id: 7, name: 'Engine Bay Cleaning', price: '$75.00', duration: '5 mins' },
  { id: 8, name: 'Headlight Restoration', price: '$50.00', duration: '5 mins' },
  { id: 9, name: 'Clay Bar & Paint Decontamination', price: '$75.00', duration: '5 mins' },
  { id: 10, name: 'Water Spot Removal', price: '$150.00', duration: '5 mins' }
];

export const beforeAfterGallery = [
  {
    id: 1,
    before: 'https://images.unsplash.com/photo-1486496146582-9ffcd0b2b2b7?w=500',
    after: 'https://images.unsplash.com/photo-1580679568899-be51739ba2df?w=500'
  },
  {
    id: 2,
    before: 'https://images.unsplash.com/photo-1449130015084-2fbf18ffb5cc?w=500',
    after: 'https://images.unsplash.com/photo-1541348263662-e068662d82af?w=500'
  },
  {
    id: 3,
    before: 'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500',
    after: 'https://images.unsplash.com/photo-1614200179396-2bdb77ebf81b?w=500'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Michael Rodriguez',
    rating: 5,
    text: 'OJ did an amazing job on my Tesla! The ceramic coating is incredible and the interior looks brand new. Worth every penny!',
    date: 'February 2026'
  },
  {
    id: 2,
    name: 'Sarah Thompson',
    rating: 5,
    text: 'Best mobile detailing service in Sacramento! They came to my office and my car was spotless when I got off work. Highly recommend!',
    date: 'January 2026'
  },
  {
    id: 3,
    name: 'David Chen',
    rating: 5,
    text: 'Professional, punctual, and the results are outstanding. My Mercedes has never looked better. Will definitely be using them again!',
    date: 'January 2026'
  },
  {
    id: 4,
    name: 'Jessica Martinez',
    rating: 5,
    text: 'The interior shampoo service removed stains I thought were permanent. Incredible attention to detail and customer service!',
    date: 'December 2025'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What areas do you service?',
    answer: 'We proudly serve Sacramento and the surrounding areas, including Roseville, Elk Grove, Folsom, Rancho Cordova, Granite Bay, and more! We bring our detailing services right to your doorstep.'
  },
  {
    id: 2,
    question: 'How do I book a detailing service?',
    answer: 'Booking is simple! You can either call us at (916) 299-3189 or use our online booking system to choose your package and schedule an appointment at a time that works for you.'
  },
  {
    id: 3,
    question: 'What is included in a detailing package?',
    answer: 'Our detailing packages include exterior washes, interior vacuuming, waxing, shampooing, and more! Each package is designed to give your vehicle a comprehensive cleaning, with additional services available for a more personalized touch.'
  },
  {
    id: 4,
    question: 'Do I need to be home for the service?',
    answer: "No, you don't need to be home! We come to you—whether you're at home, at work, or anywhere else within our service area. We make it convenient for you."
  },
  {
    id: 5,
    question: 'How long does a typical detail take?',
    answer: 'Depending on the package and vehicle condition, services range from 30 minutes for basic maintenance to 3-4 hours for comprehensive detailing with ceramic coating.'
  },
  {
    id: 6,
    question: 'What is ceramic coating and is it worth it?',
    answer: 'Ceramic coating is a liquid polymer that bonds with your vehicle\'s paint to provide long-lasting protection against UV rays, dirt, and minor scratches. It creates a hydrophobic surface that makes cleaning easier and maintains that showroom shine. It\'s definitely worth it for long-term vehicle protection!'
  }
];

export const serviceAreas = [
  'Sacramento',
  'Roseville',
  'Elk Grove',
  'Folsom',
  'Rancho Cordova',
  'Rocklin',
  'Granite Bay',
  'Fair Oaks',
  'Citrus Heights',
  'West Sacramento'
];

export const youtubeVideos = [
  {
    id: 1,
    title: 'How Much I Charge For My Detailing Packages',
    videoId: 'L7UqHLNY-Zc',
    thumbnail: 'https://img.youtube.com/vi/L7UqHLNY-Zc/maxresdefault.jpg'
  },
  {
    id: 2,
    title: 'Boss Detailing Pros on Good Day Sacramento',
    videoId: 'qRiTCzOEfeM',
    thumbnail: 'https://img.youtube.com/vi/qRiTCzOEfeM/maxresdefault.jpg'
  },
  {
    id: 3,
    title: 'Using My Vacuum As An Extractor',
    videoId: 'kGAPpTuXcEA',
    thumbnail: 'https://img.youtube.com/vi/kGAPpTuXcEA/maxresdefault.jpg'
  },
  {
    id: 4,
    title: 'My Detailing Process For First 6 Months',
    videoId: 'fgGHLgAd7lY',
    thumbnail: 'https://img.youtube.com/vi/fgGHLgAd7lY/maxresdefault.jpg'
  }
];

export const whyChooseFeatures = [
  {
    id: 1,
    icon: 'MapPin',
    title: 'Convenience',
    description: 'We come to you - home, office, or anywhere in Sacramento'
  },
  {
    id: 2,
    icon: 'Award',
    title: 'Premium Quality',
    description: 'Professional-grade products and expert techniques'
  },
  {
    id: 3,
    icon: 'Leaf',
    title: 'Eco-Friendly Products',
    description: 'Safe for your vehicle and the environment'
  },
  {
    id: 4,
    icon: 'ThumbsUp',
    title: 'Satisfaction Guaranteed',
    description: '5-star rated service with a 100% satisfaction promise'
  },
  {
    id: 5,
    icon: 'Package',
    title: 'Flexible Packages',
    description: 'Customizable options to fit your needs and budget'
  }
];

export const processSteps = [
  {
    id: 1,
    number: '1',
    title: 'Book Your Detail',
    description: 'Choose a package and schedule an appointment hassle-free.'
  },
  {
    id: 2,
    number: '2',
    title: 'We Come to You',
    description: 'Home, office, or anywhere in Sacramento—we bring the shine to you.'
  },
  {
    id: 3,
    number: '3',
    title: 'Expert Detailing',
    description: 'Interior deep clean, exterior polish, and protection for a flawless finish.'
  },
  {
    id: 4,
    number: '4',
    title: 'Final Touch',
    description: 'We inspect every inch to ensure perfection before handing back your ride.'
  }
];
